import { ReactNode } from 'react';
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid';

import { BodySmall } from '@common/body';
import { H5 } from '@common/headline';

export const AlertWithDescription = ({
  title,
  description,
}: {
  title: string;
  description: ReactNode;
}): JSX.Element => (
  <div className="mb-8 rounded-md bg-yellow-50 p-4 drop-shadow-lg">
    <div className="flex">
      <div className="shrink-0">
        <ExclamationTriangleIcon
          className="h-5 w-5 text-yellow-400"
          aria-hidden="true"
        />
      </div>
      <div className="ml-3">
        <H5>
          <span className="text-sm font-medium text-yellow-800">{title}</span>
        </H5>
        <div className="mt-2 text-yellow-700">
          <BodySmall>{description}</BodySmall>
        </div>
      </div>
    </div>
  </div>
);
